<template>
    <Pagebody :loading='loading' :subnav="[]">
        <div class="question-wrap">
            <h4>电脑版软件购买相关:</h4>
            <div class="question-box" v-for='(item, index) in appQuestion' :key='item.q'>
                <h5 @click="actQuetion(item)">{{index + 1}}.{{item.q}}</h5>
                <div class="content" :style="computeHeight(item,'app_'+index)">
                    <div style="padding-top:10px;">
                        <div class="background" :ref='"app_"+index' v-html='item.a'></div>
                    </div>
                </div>
            </div>

            <h4 style="margin-top:40px;">发票相关:</h4>
            <div class="question-box" v-for='(item, index) in invoiceQuestion' :key='item.q'>
                <h5 @click="actQuetion(item)">{{index + 1}}.{{item.q}}</h5>
                <div class="content" :style="computeHeight(item,'invoice_'+index)">
                    <div style="padding-top:10px;">
                        <div class="background" :ref='"invoice_"+index' v-html='item.a'></div>
                    </div>
                </div>
            </div>

            <h4 style="margin-top:40px;">授权相关:</h4>
            <div class="question-box" v-for='(item, index) in authQuestion' :key='item.q'>
                <h5 @click="actQuetion(item)">{{index + 1}}.{{item.q}}</h5>
                <div class="content" :style="computeHeight(item,'auth_'+index)">
                    <div style="padding-top:10px;">
                        <div class="background" :ref='"auth_"+index' v-html='item.a'></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="largeImg" v-show="showLarge">
            <img :src="requireSrc" alt="">
            <span class="close" @click="closeImg"></span>
        </div>
    </Pagebody>
</template>

<script>
    // @ is an alias to /src
    import q3img1 from '@/assets/image/cjwt1.jpg'
    import q3img2 from '@/assets/image/cjwt2.jpg'
    import img3 from '@/assets/image/dzfp.jpg'
    import commonData from '../../plugins/FetchCommonData/'
    export default {
        name: 'Question',
        components: {

        },
        data: () => ({
            loading: false,
            showLarge: false,
            requireSrc: '',
            appQuestion: [],
            invoiceQuestion: [
                {
                    q: '如何获得发票？',
                    a: '我司提供电子发票。自授权生效之日起一周后，登录“个人中心”下载电子发票。',
                    active: false
                },
                {
                    q: '如何开具增值税专用发票？',
                    a: '开具增值税专用发票需要以公对公汇款的方式付款，并在购买时根据提示填写增值税开票信息。',
                    active: false
                },
                /*{
                    q: '如何收取发票？',
                    a: '<p>个人购买可通过预留的手机号以短信的形式接收电子发票，公司购买在付款到账后除以短信的形式接收电子发票外也可向4008113366申请获得纸质发票（必需是公司银行向我司汇款）。</p>',
                    active: false
                },
                {
                    q: '开发票的注意事项？',
                    a: `<p>（1）在线支付订单只能开具普通发票，如需开具增值税专用发票请阅读本文档第3条。</p>

                        <p>（2）在线支付，购买人即为发票名头。</p>

                        <p>（3）汇款购买，汇款人银行账户姓名即为发票名头。</p>

                        <p>（4）发票内容：软件服务费。</p>

                        <p>（5）发票寄出时间：电子发票在成功支付并接受服务3个工作日即可获取，纸质专用发票在五个工作日左右寄出。</p>`,
                    active: false
                },
                {
                    q: '如何开具纸质发票（增值税专用发票）？',
                    a: `<p>开具增值税专用发票需要通过汇款到招行（参见本页授权相关问题1订单支付失败怎么办）的方式付款，并在购买时根据提示填写以下开票信息：</p>

                            <p>（1）公司名称：与营业执照的名称一致</p>

                            <p>（2）纳税人识别号：尚未办理三证合一的公司，纳税人识别号与税务登记证上的号码一致；已经办理三证合一<br>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;的公司，需与您的财务确认是使用之前税务登记证上的号码还是三证合一后的营业执照上的统一社会信用代码号</p>

                            <p>（3）地址：与营业执照上的地址一致</p>
                             <p>（4）电话：公司座机电话</p>
                             <p>（5）开户行及账号：与银行开户许可证上的账号一致</p>

                            <p>因为您提供的信息有误产生的跨月退票，我公司不负责退票。</p>

                            `,
                    active: false
                },
                // {
                //     q: '电子发票与普通发票使用有区别吗？',
                //     a: `<p>国家税务总局公告2015年第84号《关于推行通过增值税电子发票系统开具的增值税电子普通发票有关问题的公告》中指出：</p>
                //         <p>增值税电子普通发票，其法律效力、基本用途、基本使用规定等与税务机关监制的增值税普通发票相同。</p>
                //         <p>与普通发票相同，电子发票开具后，将不可更改发票信息及更换其他种类发票。（特殊问题，请咨询4008113366）</p>`,
                //     active: false
                // },
                {
                    q: '我司电子发票实施的开始时间？',
                    a: `<p>为积极推进发票无纸化，节约社会资源，方便消费者保存使用发票，我司于2018年1月1日起推出增值税电子普通发票（以下简称电子发票），即：从2018年1月1日起，我司只开具增值税普通发票（电子发票）和增值税专用发票（纸质发票）。</p>
							
							`,
                    active: false
                },
                // {
                //     q: '电子发票在付款后多久开具？',
                //     a: `<p>成功支付并接受服务3个工作日后将可获取电子发票，发票开具成功后也会手机短信通知用户。</p>
                //         <p>注：对于跨月提前付款的客户，请于开通服务月份的第3个工作日登录本网站用户中心查看和下载电子发票。</p>`,
                //     active: false
                // },
                {
                    q: '电子发票如何验证？',
                    a: `<p>电子发票下载后，客户可以凭电子发票上标识的发票代码、发票号码及校验码在国家税务局或其他授权网站进行查询。</p>
                        <p>国家税务总局全国增值税发票查验平台：<a href="https://inv-veri.chinatax.gov.cn/" target="_blank">https://inv-veri.chinatax.gov.cn/</a></p>`,
                    active: false
                },
                // {
                //     q: '个人购买可以开电子发票吗？',
                //     a: `<p>个人支付并开具个人名头发票的，均统一开具电子发票，更加快捷安全方便。</p>`,
                //     active: false
                // },
                // {
                //     q: '单位购买可以开电子发票吗？',
                //     a: `<p>电子发票是税务局认可的有效凭证，可以报销入账，其法律效力与纸质发票一致。</p>`,
                //     active: false
                // },
                // {
                //     q: '电子发票的优点？',
                //     a: `<p>（1）电子发票开具及时，查询方便，不易损坏和丢失，可重复打印。</p>
                //         <p>（2）电子发票自行打印，不需要邮寄，不需要再提供邮寄地址，也避免了邮寄丢失的风险，方便安全。</p>
                //         <p>（3）客户后续产生退款，不需要找到之前开具的发票才能办理退款，系统会自动作废之前的票据，重新开具差额发票，客户自行下载差额发票即可。</p>`,
                //     active: false
                // },
                // {
                //     q: '电子发票下载有没有次数限制？',
                //     a: `<p>电子发票没有下载次数的限制。</p>`,
                //     active: false
                // },
                */
            ],
            authQuestion: [
                // {
                //     q: '订单支付失败怎么办？',
                //     a: `<p>最常见的订单支付失败原因是浏览器开启了“广告过滤”或“弹出窗口拦截”，请关闭浏览器的“广告过滤”或“弹出窗口拦截”选项，该设置通常在浏览器的工具菜单下。设置好后重新支付即可，之前的订单会自动作废。</p>
                //         <p>如依旧无法支付请致电金融工程师400-811-3366。</p>`,
                //     active: false
                // },
                // {
                //     q: '开通后如何获得账号？',
                //     a: `<p>在线支付完成后，工作时间（8：00－11：00 ~ 13：00－17：00）内账号会在3个小时内开通。</p>`,
                //     active: false
                // },
                // {
                //     q: '支付后账号多久可开通？',
                //     a: `<p>自预留的手机号接收到开通账号的短信通知。</p>`,
                //     active: false
                // },
                {
                    q: '授权时间如何计算？',
                    a: `<p>授权时间以年为单位，自付款成功日或约定的日期起至次年前一日为止，例如2024年7月9日开通的账号则截止日期是2025年7月8日。</p>`,
                    active: false
                },
                // {
                //     q: '如何联系文华财经？',
                //     a: `<p>您可以致电金融工程师400-811-3366（工作日8:00～22:00，周末9:00～20:00）与我们取得联系。</p>`,
                //     active: false
                // },
                {
                    q: '如何修改密码？',
                    a: `<p>进入<a href="https://u.wenhua.com.cn/" style="text-decoration: none;" target="_blank">个人中心</a>->行情账号管理->修改密码。</p>`,
                    active: false
                },
            ]
        }),
        methods: {
            actQuetion (item) {
                item.active = !item.active
                var keys = ['appQuestion','invoiceQuestion','authQuestion'] //遍历所有问题，点击任何一个问题，其它问题都要收起
                keys.forEach(key=>{
                    this[key].forEach(v=>{
                        if (v.q !=item.q || v.a != item.a) {
                            v.active = false
                        }
                    })
                })
            },
            computeHeight(item, key) {
                if (!item.active) {
                    return {
                        height: '0px'
                    }
                } else {
                    return {
                        height: this.$refs[key][0].offsetHeight + 10 + 'px'
                    }
                }
            },
            closeImg(){
                this.showLarge = false
            }
        },
        watch: {
            $route(to,from){
                
            }
        },
        async mounted() {
            
            this.$nextTick(() => {
                let magimg1 = document.getElementsByClassName("q3img1")[0]
                let magimg2 = document.getElementsByClassName("q3img2")[0]
                magimg1.onclick = () => {
                    this.showLarge = true
                    this.requireSrc = magimg1.getAttribute("src")
                }
                magimg2.onclick = () => {
                    this.showLarge = true
                    this.requireSrc = magimg2.getAttribute("src")
                }
            })
            let wt9 = await commonData('appShortName_17')
            let wt8 = await commonData('appShortName_11')
            let wt7 = await commonData('appShortName_12')
            let wh6 = await commonData('appShortName_10')
            this.appQuestion = [{
                    q: '如何获得国外交易所实时行情数据？',
                    a: '需要另外付费才能看到。',
                    active: false
                },
                {
                    q: '如何查看国外交易所实时行情？',
                    a: `${wh6}是期货公司定制专用版本，无法提供选配功能/数据服务。<br>境外交易所的数据是收费的，只能通过${wt7}、${wt8}、${wt9}等收费软件提供。首先你要成为${wt7}、${wt8}或${wt9}的用户，然后选配交易所数据即可，大多数交易所的价格为570元/交易所/年。<br>注：如你没有量化、套利等功能要求，使用${wt7}软件即可，7E个人版的价格为1800元/年`,
                    active: false
                },
                {
                    q: '如何购买数据等收费服务？',
                    a: `<p>进入文华小超市（<a href="https://pay.wenhua.com.cn" target="_blank">https://pay.wenhua.com.cn</a>），选择适合的软件套餐后选配数据。</p>
                        <p>如下图，点击“国内五档数据等”“境外实时数据”，在展开的列表里勾选需要的数据授权。</p>
                        <div class="magnifyBox"><img src="${q3img1}" class="q3img1" /></div>
                        <p style="color: rgb(197, 89, 17);text-align: justify;margin: 0 2em;text-indent: 0;">
                            <strong>提示1：</strong>如只有选配数据服务需求，基础服务请选择7E个人版即可。
                        </p>
                        <p style="color: rgb(197, 89, 17);text-align: justify;margin: 0 2em;text-indent: 0;">
                            <strong>提示2：</strong>如已有按年付费并且有效期大于1个月的授权账号，可在“加购授权”项下（如下图所示）按页面提示增加购买选配数据服务。
                        </p>
                        <div class="magnifyBox"><img src="${q3img2}" class="q3img2" /></div>`,
                    active: false
                },
                {
                    q: 'PC版软件购买了国外交易所实时行情，手机软件随身行上是否也可以看到？',
                    a: '<p>付费的账号在电脑平台和手机平台不通用，需要分别购买。</p>',
                    active: false
                },
                {
                    q: '付款后如何获得授权账号？',
                    a: '<p>支付完成后，工作日的（8：00－11：00 ~ 13：00－17：00）3个小时内，你预留的手机号将接收到授权账号短信，如没有接收到短信可致电4008113366人工查询。</p>',
                    active: false
                },
                {
                    q: '授权账号快到期了，如何续费？',
                    a: '<p>授权账号到期前3个月内可到软件帮助-&gt;购买使用授权，选择相应的软件套餐进行续费。</p>',
                    active: false
                },
            ]
        },
    }
</script>

<style scoped>
    .question-wrap {
        padding: 20px 20px 20px 32px;
    }

    .question-wrap h4 {
        padding: 0;
        margin: 0;
        font-size: 14px;
        margin-bottom: 20px;
    }

    .question-box {
        margin-bottom: 20px;
    }

    .question-box h5 {
        height: 19px;
        background: url(../../assets/image/q_icon.gif) no-repeat left center;
        padding-left: 26px;
        line-height: 19px;
        color: #003586;
        font-size: 14px;
        font-weight: bolder;
        margin-bottom: 20px;
        cursor: pointer;
        margin-top: 0;
        margin-bottom: 0;
    }

    .question-box h5:hover {
        color: #ff762b;
    }

    .question-box .content {
        overflow: hidden;
        transition: height .3s;
    }

    .question-box .content .background {
        background: #F5F6F5;
        padding: 11px 17px;
        color: #636363;
        line-height: 22px;
        font-size: 12px;
        border: 1px solid #E1E1E1;
        border-radius: 3px;
        position: relative;
    }

    .question-box .content .background::before {
        content: '';
        border-bottom: 8px solid #e1e1e1;
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        position: absolute;
        left: 20px;
        top: -8px;
    }

    .question-box .content .background::after {
        content: '';
        border-bottom: 8px solid #f5f6f5;
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        position: absolute;
        left: 20px;
        top: -7px;
    }
    .largeImg{
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 11;
        background-color: rgba(0, 0, 0, .8);
        text-align: center;
    }

    .largeImg::before{
        content: '';
        display: inline-block;
        width: 0;
        height: 100%;
        vertical-align: middle;
    }

    .largeImg img{
        max-width: 99%;
        vertical-align: middle;
    }

    .close{
        position: absolute;
        display: block;
        width: 30px;
        height: 30px;
        background: rgba(255, 255, 255, .9);
        border-radius: 50%;
        border: 1px solid #333;
        right: 20px;
        top: 20px;
        z-index: 12;
        cursor: pointer;
        box-shadow: 0px 0px 20px -1px #fff;
    }
    .close::before{
        content: '';
        display: block;
        width: 3px;
        height: 25px;
        background-color: #666;
        transform: rotate(45deg);
        position: absolute;
        left: 14px;
        top: 3px;
    }
    .close::after{
        content: '';
        display: block;
        width: 3px;
        height: 25px;
        background-color: #666;
        transform: rotate(-45deg);
        position: absolute;
        left: 14px;
        top: 3px;
    }
</style>
<style>
    .magnifyBox{
        width: 515px;
        position: relative;
        cursor: pointer;
        padding: 1px;
        margin: 10px auto 20px;
        border: 1px solid #fa9a02;
        font-size: 0;
        line-height: 0;
    }

    .magnifyBox::after{
        content: '';
        width: 51px;
        height: 47px;
        background-image: url('../../assets/image/magnifying.png');
        position: absolute;
        right: 0;
        bottom: 0;
        z-index: 10;
    }

    .magnifyBox img{
        width: 515px;
    }

</style>